import { Route } from '@angular/router';
import { ClientComponent } from 'src/app/pages/client/client.component';
import { RoutingID } from '../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { ClientOverviewComponent } from '../../../pages/client/overview/client-overview.component';
import { ClientUserManagementComponent } from '../../../pages/client/user-management/client-user-management.component';
import { ClientRoleManagementComponent } from '../../../pages/client/role-management/client-role-management.component';
import { ClientInvitationsComponent } from '../../../pages/client/invitations/client-invitations.component';
import { WebSettingsComponent } from '../../../pages/client/settings/web-settings.component';
import { ClientConnectionsComponent } from '../../../pages/client/connections/client-connections.component';
import { ClientUserEditModalComponent } from '../../../pages/client/user-management/edit/client-user-edit-modal.component';
import { ApiKeyListComponent } from '../../../pages/client/api-key-list/api-key-list.component';

export const clientManagement: Route = {
  path: 'client-management',
  title: 'nav.client.myCompany',
  data: {
    breadcrumb: 'nav.client.myCompany',
    icon: SbIcons.companyClient,
    id: RoutingID.client,
  },
  children: [
    {
      path: '',
      component: ClientComponent,
      data: {
        breadcrumb: '',
      },
      children: [
        {
          path: 'client-overview',
          component: ClientOverviewComponent,
          title: 'nav.client.myCompany',
          data: {
            breadcrumb: 'nav.overview',
            icon: SbIcons.eye,
            id: RoutingID.clientOverview,
          },
        },
        {
          path: 'client-users',
          component: ClientUserManagementComponent,
          title: 'nav.client.myCompany',
          data: {
            breadcrumb: 'lang.globals.userManagement',
            icon: SbIcons.userManagement,
            id: RoutingID.clientUserManagement,
          },
          children: [
            {
              path: 'create',
              component: ClientUserEditModalComponent,
              title: 'nav.users.create',
              data: {
                breadcrumb: 'nav.users.create',
                icon: SbIcons.plus,
                id: RoutingID.clientUserCreate,
              },
            },
            {
              path: 'edit/:clientUserID',
              component: ClientUserEditModalComponent,
              title: 'nav.users.edit',
              data: {
                breadcrumb: 'nav.users.edit',
                icon: SbIcons.pen,
                id: RoutingID.clientUserEdit,
              },
            },
          ],
        },
        {
          path: 'client-roles',
          component: ClientRoleManagementComponent,
          title: 'nav.client.myCompany',
          data: {
            breadcrumb: 'lang.globals.roleManagement',
            icon: SbIcons.userRoles,
            id: RoutingID.clientRoleManagement,
          },
        },
        {
          path: 'client-connections',
          component: ClientConnectionsComponent,
          title: 'nav.client.myCompany',
          data: {
            breadcrumb: 'lang.globals.connectedClients',
            icon: SbIcons.company,
            id: RoutingID.clientConnections,
          },
          children: [
            {
              path: 'create-client-connection',
              component: ClientConnectionsComponent,
              title: 'nav.client.myCompany',
              data: {
                breadcrumb: 'lang.globals.connectedClients',
                icon: SbIcons.company,
                id: RoutingID.createClientConnection,
              },
            },
          ],
        },
        {
          path: 'client-invitations',
          component: ClientInvitationsComponent,
          title: 'nav.client.myCompany',
          data: {
            breadcrumb: 'lang.globals.invitations',
            icon: SbIcons.link,
            id: RoutingID.clientInvitations,
          },
        },
        {
          path: 'client-settings',
          component: WebSettingsComponent,
          title: 'nav.client.myCompany',
          data: {
            breadcrumb: 'lang.globals.settings',
            icon: SbIcons.settings,
            id: RoutingID.clientSettings,
          },
        },
        {
          path: 'client-apiKeys',
          component: ApiKeyListComponent,
          title: 'lang.globals.apiKeys',
          data: {
            breadcrumb: 'lang.globals.apiKeys',
            icon: SbIcons.password,
            id: RoutingID.clientApiKeys,
          },
        },
        {
          path: '',
          redirectTo: RoutingID.clientOverview,
          pathMatch: 'full',
        },
      ],
    },
  ],
};
